
import { BaseEntity } from "../entity/baseEntity";

export class BaseOwnerEntity extends BaseEntity {
  ownerId?: number;

}
